import {EmployeeRoleEnum} from "../employee/employee-role.enum";
import {EnumOpportunityStatus} from "../enum/enum-opportunity-status";
import {EnumSalesFileStatus} from "../enum/enum-sales-file-status";
import {ClientInfos} from "../quote/client-informations";
import {QuoteSummary} from "../quote/quote-summary";
import {Employee} from "../employee/employee.model";
import {EnumOpportunityType} from "../enum/enum-opportunity-type";

export class Opportunity {
    id?: number;
    client?: ClientInfos;
    employee?: Employee;
    label?: string;
    creationDate?: Date;
    status?: EnumOpportunityStatus;
    salesFileStatus?: EnumSalesFileStatus;
    mainQuoteId : string;
    roleCode: EmployeeRoleEnum;
    quotes?: QuoteSummary[];
    eforceOpportunityId?: string;
    offlineId?: string;
    mainQuoteOfflineId?: string;
    isSynchronized?: boolean;
    opportunityType?: EnumOpportunityType;
}
